import Container from '../../components/Layout/Container';
import common from './Common.module.scss';
import local from './SectionBreak.module.scss';
import avatarImg from '../../assets/images/break1-avatar.svg';
import { Alert, Button } from 'antd';
import { useSurveyContext } from '../../context/SurveyContext';
import { useSurveySubmit } from './useSurveySubmit';

const Section1Break = () => {
  const { surveyState, setCurrentStep, setCurrentSection, setCurrentSubsection } = useSurveyContext();
  const { submit, isSubmitting, error } = useSurveySubmit();

  const handleContinue = () => {
    // Move to section 2, starting from subsection 0
    setCurrentSection(1);
    setCurrentSubsection(0);
    setCurrentStep('section-2');
  };

  // A section key only exists once that section has been answered, so the
  // accumulated answers here are Section 1 alone — nothing to strip.
  const handleStop = () => {
    submit(surveyState.answers);
  };

  return (
    <div className={`${common.surveyWrapper} ${local.breakWrapper}`}>
      <Container>
        <div className={common.surveyAvatarWrapper}>
          <img src={avatarImg} alt="Survey Break Avatar" className={common.surveyAvatar} />
        </div>
        <div className={common.surveyTextSection}>
          <h1 className={common.surveyTitle}>You’ve just unlocked your dominant limiting belief</h1>
          <div className={local.breakParagraphs}>
            <p>That’s a meaningful start and knowing what’s holding you back is the first step to moving forward.</p>
            <p>If you’re ready to dive deeper, let’s move into Section 2, where you’ll discover your core personality and inner drive the traits that guide your decisions, behaviors, and motivations.</p>
            <p>This section is optional, but it can offer valuable clarity if you’re exploring your identity or feeling a bit lost.</p>
          </div>
          {error && (
            <div className={local.breakError}>
              <Alert type="error" message={error} showIcon />
            </div>
          )}
          <div className={local.breakButtonRow}>
            <Button
              className={local.breakSecondaryButton}
              onClick={handleStop}
              loading={isSubmitting}
            >
              Send Report to Email
            </Button>
            <Button
              type="primary"
              className={local.breakPrimaryButton}
              onClick={handleContinue}
              disabled={isSubmitting}
            >
              Continue
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Section1Break;
